!function() {
  "use strict";

  function galleryCollapse() {
    const galeries = document.querySelectorAll('media-gallery');

    if (galeries.length) {
      galeries.forEach(gallery => {
        const galleryContainer = gallery.querySelector('.product__media-list');
        const firstPhoto = gallery.querySelector('.product__media-list > li:first-child');
        const sixthPhoto = gallery.querySelector('.product__media-list > li:nth-child(6)');

        if (galleryContainer && firstPhoto && sixthPhoto) {
          const firstOffset = firstPhoto.offsetTop;
          const sixthOffset = sixthPhoto.offsetTop;

          if (firstOffset != sixthOffset) {
            galleryContainer.style.maxHeight = sixthPhoto.offsetTop + 100 + 'px';
            galleryContainer.classList.add('product__media-list--collapsed');
          } else {
            galleryContainer.style.maxHeight = 'auto';
            galleryContainer.classList.remove('product__media-list--collapsed');
          }
        }

        const btn = gallery.querySelector('.product__media-list__trigger');

        if (galleryContainer && btn) {
          btn.addEventListener('click', () => {
            galleryContainer.style.maxHeight = 'none';
            galleryContainer.classList.remove('product__media-list--collapsed');
          });
        }
      });
    }
  }
  
  document.addEventListener("DOMContentLoaded", () => {
    galleryCollapse();
  
    window.addEventListener("resize", () => {
      galleryCollapse();
    });
  });
  
} ();